Customer.Ticket ||= {}

class Customer.Ticket.InteractionScheduleSuspendedByOperatorDetailsView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/interaction_schedule/interaction_schedule_suspended_by_operator_details']
  className: 'interaction-schedule-details suspended-by-operator'

  initialize: (@options = {}) ->
    @schedule = @options.schedule

  render: ->
    @$el.html(@template(@schedule))
    @
